import { render, staticRenderFns } from "./consulta_pets_paciente.vue?vue&type=template&id=26cb272e&scoped=true"
import script from "./consulta_pets_paciente.vue?vue&type=script&lang=js"
export * from "./consulta_pets_paciente.vue?vue&type=script&lang=js"
import style0 from "./consulta_pets_paciente.vue?vue&type=style&index=0&id=26cb272e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb272e",
  null
  
)

export default component.exports